import { useMemo } from 'react'

let id = 0
const generateId = () => `id-${++id}`

export function useId(initialId?: string) {
  return useMemo(() => initialId || generateId(), [initialId])
}
